import React, { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { routes } from './app/router';
import MarketingConsentBanner from './components/common/MarketingConsentBanner';
import { loadChannelTalkForPublicPage } from './lib/channelTalk';
import './App.css';

// 라우터 생성
const router = createBrowserRouter(routes);

const App: React.FC = () => {
  useEffect(() => {
    loadChannelTalkForPublicPage();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2563eb',
          colorBgBase: '#f6f8fb',
          colorBgContainer: '#ffffff',
          colorBgElevated: '#ffffff',
          colorTextBase: '#172033',
          colorBorder: '#dfe7f1',
          borderRadius: 8,
          fontFamily: "'Pretendard', 'Inter', sans-serif",
          wireframe: false,
        },
        components: {
          Card: {
            colorBgContainer: '#ffffff',
            colorBorderSecondary: '#dfe7f1',
            boxShadowTertiary: '0 4px 14px rgba(31, 41, 55, 0.08)',
            borderRadiusOuter: 8,
          },
          Button: {
            controlHeight: 40,
            borderRadius: 8,
            colorPrimary: '#2563eb',
            colorPrimaryHover: '#1d4ed8',
            colorPrimaryActive: '#1e40af',
            boxShadow: '0 2px 6px rgba(37, 99, 235, 0.2)',
          },
          Input: {
            controlHeight: 40,
            borderRadius: 8,
            colorBgContainer: '#ffffff',
            colorBorder: '#cbd5e1',
          },
          Select: {
            controlHeight: 40,
            borderRadius: 8,
            colorBgContainer: '#ffffff',
            colorBorder: '#cbd5e1',
          }
        },
      }}
    >
      <RouterProvider router={router} />
      <MarketingConsentBanner />
    </ConfigProvider>
  );
};

export default App;
